/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnInit,
} from '@angular/core';

const DAY_MS = 1000 * 60 * 60 * 24;

export function daysSince(date: Date, now = Date.now()): number {
  return Math.round((now - date.getTime()) / DAY_MS);
}

// Shown for the first 30 days, then every 14th day.
export function showCompletionCard(joinedAt: Date, now = Date.now()): boolean {
  const days = daysSince(joinedAt, now);
  return days <= 30 || (days - 30) % 14 === 0;
}

// Shown for the first 30 days, until every task is done.
export function showNewJoinerChecklist(user: any, joinedAt: Date, now = Date.now()): boolean {
  const complete = user.has_confirmed_email
    && user.has_payment_method
    && user.has_viewed_community_page
    && user.has_completed_profile
    && user.has_applied_to_project
    && user.has_passed_academy;
  return daysSince(joinedAt, now) <= 30 && !complete;
}

// The logged-in Home page in the 2026 design, rendered by <home> when UTEST_DESIGN_REFRESH_2026 is on.
@Component({
  selector: 'ut-dashboard',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnInit {
  user: any;
  testerAppUrl = '';
  showChecklist = false;
  showCompletion = false;

  constructor(
    @Inject('UserService') private UserService: any,
    @Inject('ConfigService') private ConfigService: any,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.UserService.me().then((res) => {
      this.user = res?.data;
      if (this.user?.is_tester) {
        const joinedAt = new Date(this.user.site_stats.joined_at);
        this.showChecklist = showNewJoinerChecklist(this.user, joinedAt);
        this.showCompletion = showCompletionCard(joinedAt);
      }
      this.cdr.markForCheck();
    }, () => {
      // Without a user, only the activity and device cards show.
    });
    this.ConfigService.config().then((res) => {
      this.testerAppUrl = res.data.profile_url;
      this.cdr.markForCheck();
    }, () => {
      // The app has already loaded this cached config, so a failure here is unlikely; links stay relative.
    });
  }
}
